import { DefaultApi } from './api'
import { CompanyData } from './interfaces'

export const sendChangePlan = (data: CompanyData) =>
  DefaultApi.request('/company/change-combo', {
    method: 'POST',
    data,
  })
